import * as React from 'react';

import { 
    Box, 
    Typography, 
    CircularProgress,
    TextField,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import { SimpleValidators, TS_CONSTS } from '../../../../utils';
import { Candid, Orders } from '../../../../controllers';

export default function Main({handleChange}){

    const started = React.useRef(false);

    const [loading, isLoading] = React.useState(true);

    const [counters, setCounters] = React.useState(undefined);

    const [search, setSearch] = React.useState('');
    const [founds, setFounds] = React.useState([]);

    const [selectedCounter, setSelectedCounter] = React.useState(undefined);
    const [counterOrders, setCounterOrders] = React.useState([]);

    React.useEffect(() => {
        if(started.current){
            return;
        }
        started.current = true;
        StartLoop();
    },[]);

    const StartLoop = async() => {
        LoadRecords();
    }

    const CreateCounters = async() => {
        var result = {}
        Object.keys(TS_CONSTS.TRACING_AREAS).map(x => {
            result[x] = {
                name : TS_CONSTS.TRACING_AREAS[x].name,
                kline_ids : TS_CONSTS.TRACING_AREAS[x].kline_ids,
                candid_id : TS_CONSTS.TRACING_AREAS[x].candid_id,
                kline_orders : [],
                candid_orders : []
            }
        });

        return result;
    }

    const LoadRecords = async() => {
        isLoading(true);
        
        const klineInfo = await GetKlineRecords();
        const candidInfo = await GetCandidRecords();
        const merged = await DataMerge(klineInfo, candidInfo);
        
        setCounters(merged);
        isLoading(false);
    }

    const GetKlineRecords = async() => {
        const response = await Orders.GetTracingReport();

        if(response === undefined){
            // say some shit ??
            return;
        }

        if(!response.success){
            return;
        }

        if(!response.found){
            return;
        }

        return await AnalizeKlineRecords(response.result)
    }

    const AnalizeKlineRecords = async(data = []) => {
        var tmp = await CreateCounters();
        
        data.forEach(x => {
            if(x.statuses === null || x.statuses === undefined){
                return;
            }

            x.statuses.forEach(y => {
                Object.keys(tmp).forEach(z => {
                    if(tmp[z].kline_ids.includes(y.id)){
                        tmp[z].kline_orders.push([`${x.id}`, x.case_serial,y.qty]);
                    }
                });
            });
        });

        return tmp;
    }

    const GetCandidRecords = async() => {
        const response = await Candid.GetTracingReport();
        const defaultResponse = await CreateCounters();

        if(response === undefined){
            // do some shit under de hood??
            return defaultResponse;
        }

        if(!response.success){
            return defaultResponse;
        }

        if(!response.found){
            return defaultResponse;
        }

        return await AnalizeCandidRecords(response.result);
    }

    const AnalizeCandidRecords = async(data = []) => {
        const unique_numbers = [... new Set(Array.from(data, x=> x.data_general.number))];
        var branching = [];
        
        for(let i = 0 ; i < unique_numbers.length; i++){
            const case_rescords = data.filter(x => x.data_general.number === unique_numbers[i]);
            branching.push(await AnailzeCandidCaseBranching(case_rescords));
        }

        var tmp = await CreateCounters();

        branching.forEach(x => {
            Object.keys(tmp).forEach(y => {
                if(tmp[y].candid_id === x[0]){
                    tmp[y].candid_orders.push([x[1], x[2], x[3]]);
                }
            });
        });

        return tmp;
    }

    const AnailzeCandidCaseBranching = async(data = []) => {
        var result = [];
        const serial = data[0].case_serial;
        const number = data[0].data_general.number;
        var max_status = 0;
        var parts = 0;

        for(let i = 0 ; i < data.length; i++){
            if(data[i].data_general.area.id > max_status){
                max_status = data[i].data_general.area.id;
                parts = data[i].data_general.counter.dhr > 0 ? data[i].data_general.counter.dhr : data[i].data_general.counter.counter;
            }
        }

        result = [max_status, number, serial, parts];
        
        return result;
    }

    const DataMerge = async(kline, candid) => {
        var final = await CreateCounters();

        Object.keys(final).forEach(x => {
            final[x].kline_orders = kline[x].kline_orders;
            final[x].candid_orders = candid[x].candid_orders;
        });

        return final;
    }

    const handleSearch = async() => {
        if(loading){
            alert('Wait , I`m still thinking');
            return;
        }

        if(search.length === 0){
            setFounds([]);
            return;
        }

        var result = [];
        
        Object.keys(counters).forEach(x => {
            if(counters[x].kline_orders.some(y => y.includes(search)) || counters[x].candid_orders.some(y => y.includes(search))){
                result.push(counters[x].name);
            }
        });

        setFounds(result);
    }

    const handleCounterSelection = async(counter) => {
        isLoading(true);
        setSelectedCounter(counter);

        var results = [];
        try{
            counter.candid_orders.forEach(x => {
                results.push({client:'Candid', order:x[0], id:x[1], qty:x[2]});
            });
            counter.kline_orders.forEach(x => {
                results.push({client:'K-Line', order:x[0], id:x[1], qty:x[2]});
            });
            
            setCounterOrders(results);
        }catch(e){
            console.log(e);
        }finally{
            isLoading(false);
        }
    }

    const handleCounterDeselection = async() =>{
        isLoading(true);
        setSelectedCounter(undefined);

        try{
            setCounterOrders([]);
        }catch(e){
            console.log(e);
        }finally{
            isLoading(false);
        }
    }

    return(
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width:'100%',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width:'100%',
                    padding: 2,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width:'100%',
                    }}
                >
                    <Typography variant='h5'>Area Report</Typography>
                    <Typography > Dashboard</Typography>
                </Box>
                
                <TextField 
                    placeholder='Find Case ID'
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <IconButton color="primary" onClick={handleSearch}>
                    <SearchIcon />
                </IconButton>

            </Box>
            
            <Divider sx={{minWidth:'100%'}}></Divider>

            {selectedCounter === undefined && (
                <TableContainer sx={{mt:2, mb:8}}>
                    <Table>
                        <TableBody>
                            
                            <TableRow
                                sx={{ borderBottom : 2, borderColor : 'gray'}}
                            >
                                <TableCell align='center'>
                                    <Typography variant='h6'> Area || Client </Typography>
                                    
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    <Typography variant='h6'> K-Line </Typography>
                                    
                                </TableCell>
                                <TableCell align='center'>
                                    <Typography variant='h6'> Candid </Typography>
                                    
                                </TableCell>
                            </TableRow>

                            {counters != undefined && Object.keys(counters).map(x => (
                                <TableRow
                                    sx={{ borderBottom : 2, borderColor : 'lightgray', backgroundColor: founds.includes(counters[x].name) ? 'lightskyblue' : ''}}
                                >
                                    <TableCell align='center' onClick={() => handleCounterSelection(counters[x])}>
                                        {counters[x].name}
                                    </TableCell>
                                    <TableCell 
                                        align='center'
                                        sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                    >
                                        {counters[x].kline_orders.length}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {counters[x].candid_orders.length}
                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            
            {selectedCounter != undefined && (
                <TableContainer sx={{mt:2, mb:8}}>
                    <Box
                        sx={{
                            display:'flex',
                            flexDirection:'row',
                            gap: 4,
                            alignItems: 'center'
                        }}
                    >
                        <Typography variant='h5'>{selectedCounter.name}</Typography>

                        <Button endIcon={<CloseIcon/>} color='error' onClick={handleCounterDeselection}>Close</Button>
                    </Box>
                    <Table>
                        <TableBody>
                            <TableRow
                                sx={{ borderBottom : 2, borderColor : 'gray'}}
                            >
                                <TableCell align='center'>
                                    <Typography variant='h6'> Client </Typography>
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={{ borderLeft : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    <Typography variant='h6'> Order ID </Typography>
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={{ borderLeft : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    <Typography variant='h6'> Case ID </Typography>
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={{ borderLeft : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    <Typography variant='h6'> Parts </Typography>
                                </TableCell>
                            </TableRow>

                            {counterOrders.map(x => (
                                <TableRow
                                    sx={{ borderBottom : 2, borderColor : 'lightgray', backgroundColor:  [search.toUpperCase(), search].some(y => [`${x.order}`, x.id].includes(y)) ? 'lightskyblue' : ''}}
                                >
                                    
                                    <TableCell 
                                        align='center'
                                    >
                                        {x.client}
                                    </TableCell>
                                    <TableCell 
                                        align='center'
                                        sx={{ borderLeft : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                    >
                                        {x.order}
                                    </TableCell>
                                    <TableCell 
                                        align='center'
                                        sx={{ borderLeft : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                    >
                                        {x.id}
                                    </TableCell>
                                    <TableCell 
                                        align='center'
                                        sx={{ borderLeft : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                    >
                                        {x.qty}
                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {loading && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems:'center',
                    }}
                >
                    <Typography 
                        sx={{
                            display: 'flex',
                            alignItems:'center',
                            gap: 2
                        }}
                    > 
                        Analizing Data 
                        <CircularProgress />
                    </Typography>
                </Box>
            )}
        </Box>
    );
}